<template>
  <v-container fluid style='background-color:white'>
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center >
            <v-card-title class='headlinestyle'><strong>{{title}}</strong></v-card-title>
          </v-layout>
          <br />
          <v-layout row wrap align-center>
            <v-flex xs6 sm2 md2 lg2>
              <div class='ml-10'><p align='right'><strong>Customer : </strong></p></div>
            </v-flex>
            <v-flex xs6 sm2 md2 lg2>
              <!-- <div> <v-text-field solo class='ml-4' readonly filled ></v-text-field></div> -->
              <div>
                <!-- <v-select
                  class='ml-4'
                  :items="useritems"
                  solo
                  dense
                  v-model="customerusername"
                  item-value="username"
                  item-text="username"
                  v-on:input="changecustomer(customerusername)"
                ></v-select> -->
                <v-autocomplete
                  class='ml-4'
                  :items="useritems"
                  solo
                  dense
                  v-model="customerusername"
                  item-value="username"
                  item-text="username"
                  v-on:input="changecustomer(customerusername)"
                ></v-autocomplete>
              </div>
            </v-flex>
            <v-flex xs6 sm1 md1 lg1>
              <div class='ml-10'><p align='right'><strong>ชื่อ-สกุล : </strong></p></div>
            </v-flex>
            <v-flex xs6 sm2 md2 lg2>
              <div> <v-text-field solo dense class='ml-4' v-model="name" readonly></v-text-field></div>
            </v-flex>
            <v-flex xs6 sm1 md1 lg1>
              <div class='ml-10'><p align='right'><strong>ที่อยู่ : </strong></p></div>
            </v-flex>
            <v-flex xs6 sm2 md2 lg2>
              <div> <v-text-field solo dense class='ml-4' v-model="address" readonly></v-text-field></div>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center>
            <v-flex xs6 sm2 md2 lg2>
              <div class='ml-10'><p align='right'><strong>เบอร์โทร : </strong></p></div>
            </v-flex>
            <v-flex xs6 sm2 md2 lg2>
              <div> <v-text-field solo dense class='ml-4' v-model='tel' readonly></v-text-field></div>
            </v-flex>
            <v-flex xs6 sm3 md3 lg3 px-10>
              <div class="round px-5" v-if="isclaim">
                <v-layout>
                  <v-flex xs1 sm1 md1 lg1>
                    <input type="checkbox" id="checkbox1" v-model="claim"/>
                    <label for="checkbox1"></label>
                  </v-flex>
                  <v-flex xs9 sm9 md9 lg9><p><strong>เคลมสินค้า</strong></p></v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>

          <v-layout row wrap justify-end v-if="isselected">
            <v-flex xs4 sm3 md3 lg3>
              <v-btn class="mx-2" outlined color="indigo lighten-2" @click="openorderproductmodal()">
                <v-icon>mdi-plus</v-icon>&nbsp;
                เพิ่ม/แก้ไข
              </v-btn>
            </v-flex>
          </v-layout>
          <br />
        <v-layout justify-center>
          <v-flex xs12 sm9 md9 lg9>
          <v-data-table
                :headers="headers"
                :items="productitems"
                hide-default-footer
                :items-per-page="1000"
                class="elevation-2"
                item-key="_id"
                disable-pagination
              >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item._id"
                    style="cursor: pointer;"
                    align='center'
                  >
                  <td>{{ item.product_no }}</td>
                  <td>
                    <v-container class="con">
                    <v-img
                      class="white--text align-center"
                      style="height:100px; width:130px;"
                      :src="item.image"
                      v-if="item.image"
                    ></v-img></v-container></td>
                  <td>{{ item.name }}</td>
                  <td v-if="!claim">{{ item.price }}</td>
                  <td v-if="claim">0</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.type }}</td>
                  <td>
                      <v-btn class="ma-2" outlined small fab color="red" @click="deleteproduct(item._id)" >
                        <v-icon meduim>mdi-delete-forever</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <br />
                  <tr>
                  <td />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td><div><p align="right"><strong>รวม </strong><small style='color: black;'>(ราคาไม่รวมภาษี)</small></p></div></td>
                  <td>
                    <p align="left" style="color: red;" v-if="!claim">{{ amount }}&nbsp;&nbsp;&nbsp;บาท</p>
                    <p align="left" style="color: red;" v-if="claim">0.00&nbsp;&nbsp;&nbsp;บาท</p>
                  </td>
                </tr>
                </tbody>
          </template>
              </v-data-table>
          </v-flex>
        </v-layout>
        <br />
        <br />
        <v-layout justify-end>
          <div class="flex-grow-1"></div>

          <v-btn class="px-5" color="pink" style="margin-right: 5px" outlined @click="cancel()">ยกเลิก</v-btn>

          <v-btn color="pink lighten-2" dark @click="save()">บันทึก</v-btn>
          <v-flex xs1 sm1 md1 lg1></v-flex>
        </v-layout>
        <br />
        <br />
        <div class="vld-parent">
          <loading :active.sync="isLoading" is-full-page></loading>
        </div>
        <Orderproductmodal />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Orderproductmodal from '@/components/Orderproductmodal'
import axios from 'axios'
import swal from 'sweetalert'
import { sync } from 'vuex-pathify'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import numeral from 'numeral'
export default {
  components: {
    Orderproductmodal,
    Loading
  },
  data: () => ({
    title: 'รายการสั่งซื้อสินค้าใหม่',
    headers: [
      { text: 'รหัสซื้อขาย', align: 'center', sortable: false, value: 'product_no' },
      { text: 'รูปสินค้า', align: 'center', sortable: false, value: 'image' },
      { text: 'ชื่อสินค้า', align: 'center', sortable: false, value: 'name' },
      { text: 'ราคา', align: 'center', sortable: false, value: 'price' },
      { text: 'จำนวน', align: 'center', sortable: false, value: 'quantity' },
      { text: 'ประเภท', align: 'center', sortable: false, value: 'type' },
      { text: 'ลบ', align: 'center', sortable: false, value: 'delete' }
    ],
    useritems: [],
    customerdata: '',
    customerusername: '',
    name: '',
    address: '',
    tel: '',
    productitems: [],
    isselected: false,
    amount: '0.00',
    claim: false,
    isLoading: false,
    isclaim: false
  }),
  created () {
    if (this.$cookies.get('token') !== '') {
      this.getdata()
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    async getdata () {
      try {
        let { data } = await axios.get(`${process.env.VUE_APP_API}/user/getinfo/customer`, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        this.useritems = data.filter(user => user.active)
        this.productitems = []
        // this.customerusername = this.useritems[0].username
        await this.changecustomer()
      } catch (error) {
      }
    },
    async setdata () {
      this.productitems = (JSON.parse(this.currentorderproduct)).filter(pd => pd.quantity > 0)
      this.setamount()
    },
    setamount () {
      this.amount = numeral(this.productitems ? this.productitems.reduce((sum, product) => {
        return sum + (Number(product.price) * Number(product.quantity))
      }, 0) : 0).format('0,0.00')
    },
    async save () {
      try {
        if (this.productitems.length !== 0 && this.customerdata.length !== 0) {
          this.isLoading = true
          let resultproductitems = this.productitems.map(pd => {
            return {
              product_id: pd._id,
              quantity: pd.quantity
            }
          })
          let { data } = await axios.post(`${process.env.VUE_APP_API}/order/create`, {
            customer_id: this.customerdata[0]._id,
            productitems: resultproductitems,
            claim: this.claim
          }, {
            headers: {
              Authorization: this.$cookies.get('token')
            }
          })
          if (data) {
            this.isLoading = false
            await swal(`สร้างรายการสั่งสินค้าใหม่เรียบร้อย!`, {
              icon: 'success',
              buttons: 'ตกลง'
            })
            this.$router.push('/approveorder')
          }
        } else if (this.customerdata.length === 0) {
          await swal({
            title: `กรุณาเลือกร้านค้า`,
            icon: 'warning',
            dangerMode: true,
            buttons: 'ตกลง'
          })
        } else if (this.productitems.length === 0) {
          await swal({
            title: `กรุณาเลือกสินค้า`,
            icon: 'warning',
            dangerMode: true,
            buttons: 'ตกลง'
          })
        } else {
          await swal({
            title: `ระบบผิดพลาด`,
            text: 'กรุณาลองอีกครั้งในภายหลัง',
            icon: 'warning',
            dangerMode: true,
            buttons: 'ตกลง'
          })
        }
      } catch (error) {
        this.isLoading = false
        await swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          dangerMode: true,
          buttons: 'ตกลง'
        })
      }
    },
    cancel () {
      this.$router.push('/approveorder')
    },
    openorderproductmodal () {
      console.log('this.productitems', this.productitems)
      this.currentorderproduct = JSON.stringify(this.productitems)
      this.currentcustomerid = this.customerdata[0]._id
      this.orderproductmodal = true
    },
    changecustomer () {
      if (this.customerusername !== '') {
        this.customerdata = this.useritems.filter(user => user.username === this.customerusername)
        this.currentcustomerid = this.customerdata[0]._id
        this.name = this.customerdata[0].name
        this.address = this.customerdata[0].address
        this.tel = this.customerdata[0].tel
        this.productitems = []
        this.amount = '0.00'
        this.isclaim = this.customerdata[0].claim
      }
    },
    deleteproduct (pid) {
      this.productitems = this.productitems.filter(pitem => pitem._id !== pid)
      this.setamount()
    }
  },
  computed: {
    orderproductmodal: sync('orderproductmodal'),
    currentorderproduct: sync('currentorderproduct'),
    currentcustomerid: sync('currentcustomerid')
  },
  watch: {
    currentorderproduct () {
      this.setdata()
    },
    currentcustomerid () {
      if (this.currentcustomerid !== '') {
        this.isselected = true
      } else {
        this.isselected = false
      }
    }
  }
}
</script>

<style scoped >
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-data-table th {
  height: 60px !important;
}
.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 2px solid #929192;
  border-radius: 50%;
  cursor: pointer;
  height: 20px;
  left: 0;
  position: absolute;
  top: 4px;
  width: 20px;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 2px;
  opacity: 0;
  position: absolute;
  top: 4.5px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #FA8072;
  border-color: #EE5787;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

.v-btn {
  font-family: 'Kanit';
  font-weight: bold;
}
</style>
